// utils/dateUtils.js

export function getTodayFr() {
  const now = new Date();
  const d = String(now.getDate()).padStart(2, "0");
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const y = now.getFullYear();
  return `${d}/${m}/${y}`; // JJ/MM/AAAA
}

export function getYesterdayIso() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`; // "2025-11-14"
}

export function getKinshasaDateIso() {
  // Kinshasa is UTC+1
  const now = new Date();
  const kinshasaTime = new Date(now.getTime() + 1 * 60 * 60 * 1000);
  const yyyy = kinshasaTime.getFullYear();
  const mm = String(kinshasaTime.getMonth() + 1).padStart(2, "0");
  const dd = String(kinshasaTime.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`; // "2026-02-05"
}

export function isoToFrDmy(isoDate) {
  if (!isoDate) return "";
  const [y, m, d] = String(isoDate).split("-");
  if (!y || !m || !d) return "";
  return `${d.padStart(2, "0")}-${m.padStart(2, "0")}-${y}`;
}

// utils/dateUtils.js

export function getNowDdMmYyyyHhMmSs() {
  const now = new Date();

  const dd = String(now.getDate()).padStart(2, "0");
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const yyyy = now.getFullYear();

  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  const ss = String(now.getSeconds()).padStart(2, "0");

  // dd-mm-yyyy-hh-mm-ss
  return `${dd}-${mm}-${yyyy}-${hh}-${min}-${ss}`;
}
